<template>
    <div>
        <div class="resource-selector">
            <multi-select :options="options"
                          @search-change="asyncQuery"
                          @select="select"
                          :internal-search="false"
                          :placeholder="placeholder"
                          :loading="isLoading">
                <template slot="singleLabel" slot-scope="{ option }">
                        <span class="option__desc">
                            <span class="option__title">{{ option.title }}</span>
                        </span>
                </template>
                <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
                        <span class="option__title">{{ option.title }}</span>
                    </div>
                </template>
                <template slot="noResult">
                    {{ $t('No results found') }}
                </template>
                <template slot="noOptions">
                    {{ $t('Start searching by typing') }}
                </template>
            </multi-select>
        </div>
        <hr>
        <div v-for="resource in resources">
            <slot :resource="resource">
                <div class="alert alert-info alert-dismissible fade show">
                    {{ resource.title }}
                    <button type="button" class="close" @click="remove(resource)">
                        <span>&times;</span>
                    </button>
                </div>
            </slot>

            <input v-for="(value, key) in resource" type="hidden"
                   :name="name + '[' + resource[identifier] + ']' + '[' + key + ']'"
                   :value="value"/>
        </div>
    </div>
</template>
<script>
    import MultiSelect from 'vue-multiselect'
    import axios from 'axios'
    import qs from 'qs'
    import _ from 'lodash'

    export default {
        components: {MultiSelect},
        props: {
            url: {
                required: true
            },
            value: {
                type: Array,
                default: () => []
            },
            name: {
                default: 'resources'
            },
            placeholder: {
                default: 'Add by searching...'
            },
            identifier: {
                default: 'id'
            }
        },
        data() {
            return {
                options: [],
                resources: this.value,
                isLoading: false
            }
        },
        methods: {
            asyncQuery(queryString) {
                if (!queryString) {
                    this.options = [];
                    return;
                }

                this.isLoading = true;
                this.makeRequest(queryString);
            },
            makeRequest: _.debounce(function (queryString) {
                axios.get(
                    this.url
                    + (this.url.indexOf('?') > 0 ? '&' : '?')
                    + qs.stringify({
                        filters: {
                            query: queryString,
                            without: _.map(this.resources, this.identifier)
                        }
                    })
                ).then((resp) => {
                    this.isLoading = false;
                    this.options = resp.data.data;
                })
                    .catch(() => this.isLoading = false)
            }, 500),
            select(resource) {
                if (_.find(this.resources, resource)) {
                    return
                }

                this.resources.push(resource)

                this.$emit('input', this.resources)
            },
            remove(resource) {
                this.resources = _.filter(this.resources, (item) => item !== resource)
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    .resource-selector {
        .resource-selector--head {
            height: 43px;
        }
    }
</style>
